import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from './components/card/card.module';
import { DatePickerComponent } from './components/datepicker/datepicker.component';
import {
  NgbModule,
  NgbNavModule,
  NgbOffcanvasModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatatableModule } from './components/datatable/datatable.module';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { ToastComponent } from './services/toast/toast.component';
import { ToastService } from './services/toast/toast.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { IconSvgComponent } from './components/icon-svg/icon-svg.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2Rut, RutValidator } from 'ng2-rut';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CapitalizeFirstPipe } from './pipe/capitalize.pipe';
import { CurrencyFormatPipe } from './pipe/currency-format.pipe';
import { ReplacePipe } from './pipe/replace.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { NguCarouselModule } from '@ngu/carousel';
import { NgSelectModule } from '@ng-select/ng-select';
import { RoundNumberPipe } from './pipe/round-number.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { CardDashboardNoChartComponent } from './components/card-dashboard-no-chart/card-dashboard-no-chart.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { PorcentajeCircleComponent } from './components/porcentaje-circle/porcentaje-circle.component';
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import { ModalModule } from './components/modal/modal.module';
import { ExcelService } from './services/excel/excel.service';
import { AlertService } from './services-v2/alert/alert.service';

@NgModule({
  declarations: [
    DatePickerComponent,
    ToastComponent,
    SpinnerComponent,
    IconSvgComponent,
    CapitalizeFirstPipe,
    CurrencyFormatPipe,
    ReplacePipe,
    LoadingComponent,
    RoundNumberPipe,
    CardDashboardNoChartComponent,
    PorcentajeCircleComponent,
    CustomModalComponent,
  ],
  imports: [
    ModalModule,
    CommonModule,
    CardModule,
    NgbModule,
    FormsModule,
    ToastrModule,
    DatatableModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2SearchPipeModule,
    Ng2Rut,
    NgApexchartsModule,
    NguCarouselModule,
    NgSelectModule,
    NgbNavModule,
    NgbOffcanvasModule,
    TooltipModule,
    GoogleMapsModule,
    NgCircleProgressModule.forRoot({
      radius: 60,
      space: -3,
      outerStrokeGradient: true,
      outerStrokeWidth: 4,
      outerStrokeColor: '#4882c2',
      outerStrokeGradientStopColor: '#53a9ff',
      innerStrokeColor: '#e7e8ea',
      innerStrokeWidth: 3,
      animateTitle: false,
      animationDuration: 250,
      showUnits: true,
      showBackground: false,
      clockwise: false,
      startFromZero: false,
      titleFontSize: '13',
      titleColor: 'black',
      unitsColor: 'black',
      showSubtitle: false,
    }),
  ],
  exports: [
    ModalModule,
    CardModule,
    DatePickerComponent,
    NgbModule,
    DatatableModule,
    ToastrModule,
    SpinnerComponent,
    IconSvgComponent,
    Ng2Rut,
    CapitalizeFirstPipe,
    NgApexchartsModule,
    CurrencyFormatPipe,
    ReplacePipe,
    LoadingComponent,
    NgSelectModule,
    NgbOffcanvasModule,
    RoundNumberPipe,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    CardDashboardNoChartComponent,
    GoogleMapsModule,
    NgCircleProgressModule,
    PorcentajeCircleComponent,
  ],
  bootstrap: [DatePickerComponent],
  providers: [
    ToastrService,
    ToastService,
    CapitalizeFirstPipe,
    RutValidator,
    CurrencyFormatPipe,
    ReplacePipe,
    ExcelService,
    AlertService
  ],
})
export class SharedModule {}
